import { Formik } from 'formik';
import React from 'react';

import * as S from './styles';
import FieldFormik from '../../../../../components/newStudent/FieldFormik';
import { ButtonSimple } from '../../../../../components/newStudent/Buttons';
import { IInternalTicketShowBody } from '../../../../../interfaces/newStudent/ticket.interface';
import { ticketStatusOptions } from '../../../../../variables/ticket';

interface Props {
  handleSearch: (body: IInternalTicketShowBody) => Promise<void>;
  initialValues: IInternalTicketShowBody;
}

export default function TicketFilter({ handleSearch, initialValues }: Props) {
  return (
    <S.Container>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={(values) => handleSearch(values)}
      >
        {(formik) => (
          <>
            <S.FieldsRow>
              <FieldFormik
                name="protocol"
                type="string"
                label="Protocolo"
                placeholder="Número do protocolo"
                value={formik.values.protocol}
                onChange={formik.handleChange}
                widthSize="fullWidth"
              />
              <FieldFormik
                name="status"
                type="select"
                label="Situação"
                value={formik.values.status}
                onChange={formik.handleChange}
                options={ticketStatusOptions}
                widthSize="fullWidth"
              />
              <FieldFormik
                name="initialDate"
                type="date"
                label="Data inicial"
                value={formik.values.initialDate}
                onChange={formik.handleChange}
                widthSize="fullWidth"
              />
              <FieldFormik
                name="finalDate"
                type="date"
                label="Data final"
                value={formik.values.finalDate}
                onChange={formik.handleChange}
                widthSize="fullWidth"
              />
            </S.FieldsRow>
            <S.ButtonDiv>
              <ButtonSimple
                color="primary"
                widthSize="medium"
                onClick={() => formik.handleSubmit()}
              >
                Filtrar
              </ButtonSimple>
              {formik.dirty && (
                <ButtonSimple
                  color="gray"
                  outline
                  widthSize="medium"
                  onClick={() => {
                    formik.resetForm();
                    handleSearch(initialValues);
                  }}
                >
                  Limpar filtro
                </ButtonSimple>
              )}
            </S.ButtonDiv>
          </>
        )}
      </Formik>
    </S.Container>
  );
}
